<template>
    <div class="Ticket">
        <TopNavBar navtitle="电子准考证"></TopNavBar>
        <Ticket :EF_ID="EF_ID"></Ticket>
    </div>
</template>

<script>
import TopNavBar from '@/components/TopNavBar.vue'
import Ticket from '@/components/Ticket.vue'
export default {
    components: {
        TopNavBar,
        Ticket
    },
    data () {
        return {
            EF_ID: ''
        }
    },
    created () {
        if (this.$route.query.EF_ID != null || this.$route.query.EF_ID != undefined) {
            this.EF_ID = this.$route.query.EF_ID;
        }
    }
}
</script>

<style>
</style>